__turbopack_context__.v({
  "addCartBtn": "ProductCard-module__GIpEvW__addCartBtn",
  "badge": "ProductCard-module__GIpEvW__badge",
  "bottomArea": "ProductCard-module__GIpEvW__bottomArea",
  "cartIcon": "ProductCard-module__GIpEvW__cartIcon",
  "cartLoadingText": "ProductCard-module__GIpEvW__cartLoadingText",
  "details": "ProductCard-module__GIpEvW__details",
  "divider": "ProductCard-module__GIpEvW__divider",
  "imageArea": "ProductCard-module__GIpEvW__imageArea",
  "img": "ProductCard-module__GIpEvW__img",
  "infoArea": "ProductCard-module__GIpEvW__infoArea",
  "oldPrice": "ProductCard-module__GIpEvW__oldPrice",
  "price": "ProductCard-module__GIpEvW__price",
  "priceActionBox": "ProductCard-module__GIpEvW__priceActionBox",
  "priceCartBtn": "ProductCard-module__GIpEvW__priceCartBtn",
  "priceHeartIcon": "ProductCard-module__GIpEvW__priceHeartIcon",
  "priceSeparator": "ProductCard-module__GIpEvW__priceSeparator",
  "priceSoldOutText": "ProductCard-module__GIpEvW__priceSoldOutText",
  "priceWishlistBtn": "ProductCard-module__GIpEvW__priceWishlistBtn",
  "productCard": "ProductCard-module__GIpEvW__productCard",
  "productTitle": "ProductCard-module__GIpEvW__productTitle",
  "salePrice": "ProductCard-module__GIpEvW__salePrice",
  "subTitle": "ProductCard-module__GIpEvW__subTitle",
  "titleBox": "ProductCard-module__GIpEvW__titleBox",
  "wishlistBox": "ProductCard-module__GIpEvW__wishlistBox",
});
